/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_MenuInputs */

const en_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File menu`)
};

const fr_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu fichier`)
};

const de_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü „Datei“`)
};

const it_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu File`)
};

const ru_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню «Файл»`)
};

const es_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú de archivo`)
};

const zh_cn2_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件菜单`)
};

const ja_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルメニュー`)
};

const hi_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल मेनू`)
};

const pt_pt2_file_menu = /** @type {(inputs: File_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu Arquivo`)
};

/**
* | output |
* | --- |
* | "File menu" |
*
* @param {File_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_menu = /** @type {((inputs?: File_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_menu(inputs)
	if (locale === "de") return de_file_menu(inputs)
	if (locale === "it") return it_file_menu(inputs)
	if (locale === "ru") return ru_file_menu(inputs)
	if (locale === "es") return es_file_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_file_menu(inputs)
	if (locale === "ja") return ja_file_menu(inputs)
	if (locale === "hi") return hi_file_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_file_menu(inputs)
	return en_file_menu(inputs)
});